
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        id: {
            type: Number,
            default: null
        },
        number: {
            type: String,
            default: null
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = () => {
            emit('click', props.id)
        }

        return { onClick }
    }
})
